import { query } from '../api/query'
import { getBooking } from '../api/getBooking'

class ConfirmBooking {
    stage = 3
    constructor(form, bookingNo) {
        this.confirmBooking = form
        this.bookingNo = bookingNo
    }

    update(currentStage) {
        if (this.isCurrentStage(currentStage)) {
            const tagBooking = this.tagBooking();

            return [tagBooking]
        }
    }

    async onLoad(currentStage) {
        if (this.isCurrentStage(currentStage)) {
            this.bookingInfo = await getBooking(this.bookingNo)
        }
    }

    showBookingInfo() {
        this.confirmBooking.innerHTML = this.bookingInfo.booking.booking_no
    }

    isCurrentStage(currentStage) {
        return currentStage == this.stage
    }

    async tagBooking() {
        const URL = this.confirmBooking.dataset.tag_booking_route

        try {
            const result = await query(URL, this.bookingNo);
            return result; 
        } catch (error) {
            console.error('Failed to update Confirm booking info:', error.message);
            throw error;  // Re-throw the error to propagate it upwards
        }
    }

}

export default ConfirmBooking